import en from './home.en';

const enConfig = { en };

export default enConfig;
